'use es6';

import { Fragment, useCallback } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Set as ImmutableSet, List as ImmutableList } from 'immutable';
import PropTypes from 'prop-types';
import identity from 'transmute/identity';
import always from 'transmute/always';
import has from 'transmute/has';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import { getChildTeams, getId, getName } from '../../../data/schemas/teamSchema';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TeamCheckboxList = ({
  teamCollection = ImmutableList(),
  value = ImmutableSet(),
  depth = 0,
  onChange = identity,
  filter = always(true)
}) => {
  const onCheckboxChange = useCallback(({
    target
  }) => {
    const {
      checked,
      value: targetValue
    } = target;
    onChange({
      checked,
      value: parseInt(targetValue, 10)
    });
  }, [onChange]);
  return /*#__PURE__*/_jsx(List, {
    paddingInlineStart: depth !== 0 ? '400' : 0,
    children: teamCollection.map(team => {
      const childTeams = getChildTeams(team);
      const teamId = getId(team);
      const showTeam = filter(team);
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [showTeam && /*#__PURE__*/_jsx(UICheckbox, {
          "data-test-id": `team-${teamId}`,
          value: teamId,
          checked: has(teamId, value),
          onChange: onCheckboxChange,
          children: getName(team)
        }, teamId), childTeams && /*#__PURE__*/_jsx(TeamCheckboxList, {
          teamCollection: childTeams,
          value: value,
          depth: depth + 1,
          onChange: onChange,
          filter: filter
        })]
      }, teamId);
    })
  });
};
TeamCheckboxList.propTypes = {
  depth: PropTypes.number,
  value: ImmutablePropTypes.set,
  teamCollection: ImmutablePropTypes.list,
  onChange: PropTypes.func,
  filter: PropTypes.func
};
const TeamCheckboxGroup = props => /*#__PURE__*/_jsx(UIToggleGroup, {
  name: "team-toggles",
  className: "m-left-4",
  children: /*#__PURE__*/_jsx(TeamCheckboxList, Object.assign({}, props))
});
export default TeamCheckboxGroup;